import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createHeaders } from './actionHelpers';

export const PARAKEY_FETCH_KEYS = 'PARAKEY_FETCH_KEYS';

export const fetchParakeyKeysForDomainId = parakeyDomainId => ({
    [RSAA]: {
        types: createRsaaTypes(PARAKEY_FETCH_KEYS),
        endpoint: `/api/parakey/domains/${parakeyDomainId}/parakeyKeys`,
        headers: createHeaders(false),
        method: 'GET'
    }
});
